import { badgeConsts, BaseBadgeStyles, BaseBadgeStylesProps, UseBadgePropsReturnType } from '@sede-x/shell-ds-react-base';
import styled, { css } from 'styled-components';

type BadgeProps = BaseBadgeStylesProps & {
  $color: UseBadgePropsReturnType['color'];
  round: UseBadgePropsReturnType['round'];
  size: UseBadgePropsReturnType['size'];
};

const Badge = styled.div<BadgeProps>`
  ${({ size, $color, round }) => css`
    ${BaseBadgeStyles}
    gap: ${badgeConsts[size].gap}px;
    width: fit-content;
    border-radius: ${round ? '50%' : '16px'};
    color: ${$color};
  `}
`;

type BadgeTextProps = {
  fontStyles: UseBadgePropsReturnType['fontStyles'];
};

const BadgeText = styled.span<BadgeTextProps>`
  ${({ fontStyles }) => css`
    ${fontStyles};
  `};
`;

export { Badge, BadgeText };
